import {Component} from '@angular/core';
import {SidebarComponent} from "../../../../sidebar/sidebar.component";
import {PanelComponent} from '../../../../panel/panel.component';

@Component({
  selector: 'app-user',
  imports: [
    SidebarComponent,
    PanelComponent
  ],
  templateUrl: './user.component.html',
  styleUrl: './user.component.css',
})
export class UserComponent {

}
